module.exports = __webpack_public_path__ + "img/no-manager-en.1915980.png";